export const CONSUMABLE = 'consumable';
export const NON_RENEWABLE_SUB = 'non-renewable_subscription';
export const RENEWABLE_SUB = 'renewable_subscription';

// used for api api key `plan_type`
export const RENEWABLE = 'renewable';
export const NON_RENEWABLE = 'non-renewable';



// WEBPACK FOOTER //
// ./app/constants/planTypes.js